import tables from "./tables"

const Select = {
    all : (table : string) => `SELECT * FROM ${table}`, 
    first : (table : string) => `SELECT * FROM ${table} LIMIT 1`,
    id : (table : string, id: number) => `SELECT * FROM ${table} WHERE Id = ${id}`,
}

const Delete = {
    all : (table : string) => `DELETE FROM ${table}`,
}

const Companies = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Companies} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Name TEXT,
        DisplayName TEXT
        );`,
    insert : `INSERT INTO ${tables.Companies} (Id, Name, DisplayName) VALUES (?,?,?);`
}

const Tenants = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Tenants} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Name TEXT,
        Path TEXT,
        Theme TEXT,
        Featured BOOLEAN NOT NULL CHECK (Featured IN (0, 1)),
        OrderPos INTEGER
        );`,
    insert : `INSERT INTO ${tables.Tenants} (Id, Name, Path, Theme, Featured, OrderPos) VALUES (?,?,?,?,?,?);`,
    retrieveOrderedList : `SELECT * FROM ${tables.Tenants} ORDER BY OrderPos ASC`
}

const NativeAppConf = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.NativeAppConf} (
        Id INTEGER PRIMARY KEY NOT NULL,
        RequirePin BOOLEAN NOT NULL CHECK (RequirePin IN (0, 1)),
        Pin INTEGER
        );`,
    insert : `INSERT INTO ${tables.NativeAppConf} (RequirePin, Pin) VALUES (?,?);`,
    update : `UPDATE ${tables.NativeAppConf} SET RequirePin = ? , Pin = ? WHERE Id = ?;`
}

const Users = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Users} (
        Id INTEGER PRIMARY KEY NOT NULL,
        UserName TEXT,
        FirstName TEXT,
        LastName TEXT
        );`,
    insert : `INSERT INTO ${tables.Users} (Id, UserName, FirstName, LastName) VALUES (?,?,?,?);`,
    update : `UPDATE ${tables.Users} SET UserName = ? , FirstName = ? , LastName = ? WHERE Id = ?;`
}

const Meetings = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Meetings} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Title TEXT,
        StartDate DATETIME,
        EndDate DATETIME,
        LastUpdateDate DATETIME,
        TenantId INTEGER
        );`,
    insert : `INSERT INTO ${tables.Meetings} (Id, Title, StartDate, EndDate, LastUpdateDate, TenantId) VALUES (?,?,datetime(?),datetime(?),datetime(?),?);`,
    update : `UPDATE ${tables.Meetings} SET Title = ? , StartDate = datetime(?) , EndDate = datetime(?), LastUpdateDate = datetime(?), TenantId = ? WHERE Id = ?;`,
    retriveByTenant : (tenantId: number) => `SELECT * FROM ${tables.Meetings} WHERE TenantId = ${tenantId} ORDER BY StartDate DESC`
}

const Nodes = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Nodes} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Title TEXT,
        OrderIndex INTEGER NOT NULL,
        ContentId INTEGER,
        ParentId INTEGER,
        MeetingId INTEGER NOT NULL
        );`,
    insert : `INSERT INTO ${tables.Nodes} (Id, Title, OrderIndex, ContentId, ParentId, MeetingId) VALUES (?,?,?,?,?,?);`,
    update : `UPDATE ${tables.Nodes} SET Title = ?, OrderIndex = ?, ContentId = ?, ParentId = ?, MeetingId = ? WHERE Id = ?;`,
    countByMeeting : (meetingId: number) => `SELECT COUNT(*) AS TotalCount FROM ${tables.Nodes} WHERE MeetingId = ${meetingId}`,
    retriveByMeeting : (meetingId: number, parentId: number | null) => `SELECT * FROM ${tables.Nodes} WHERE MeetingId = ${meetingId} AND ParentId ${!parentId ? `IS NULL` : `= ${parentId}`} ORDER BY OrderIndex ASC`,
    deleteByMeeting : (meetingId: number) => `DELETE FROM ${tables.Nodes} WHERE MeetingId = ${meetingId}`,
}

const Boards = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.Boards} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Name TEXT,
        LastUpdateDate DATETIME,
        TenantId INTEGER
        );`,
    insert : `INSERT INTO ${tables.Boards} (Id, Name, LastUpdateDate, TenantId) VALUES (?,?,datetime(?),?);`,
    update : `UPDATE ${tables.Boards} SET Name = ?, LastUpdateDate = datetime(?), TenantId = ? WHERE Id = ?;`,
    retriveByTenant : (tenantId: number) => `SELECT * FROM ${tables.Boards} WHERE TenantId = ${tenantId}`
}

const BoardNodes = {
    create : `CREATE TABLE IF NOT EXISTS ${tables.BoardNodes} (
        Id INTEGER PRIMARY KEY NOT NULL,
        Title TEXT,
        OrderIndex INTEGER NOT NULL,
        ContentId INTEGER,
        ParentId INTEGER,
        BoardId INTEGER NOT NULL
        );`,
    insert : `INSERT INTO ${tables.BoardNodes} (Id, Title, OrderIndex, ContentId, ParentId, BoardId) VALUES (?,?,?,?,?,?);`,
    update : `UPDATE ${tables.BoardNodes} SET Title = ?, OrderIndex = ?, ContentId = ?, ParentId = ?, BoardId = ? WHERE Id = ?;`,
    countByBoard : (boardId: number) => `SELECT COUNT(*) AS TotalCount FROM ${tables.BoardNodes} WHERE BoardId = ${boardId}`,
    retriveByBoard : (boardId: number, parentId: number | null) => `SELECT * FROM ${tables.BoardNodes} WHERE BoardId = ${boardId} AND ParentId ${!parentId ? `IS NULL` : `= ${parentId}`} ORDER BY OrderIndex ASC`,
    deleteByBoard : (boardId: number) => `DELETE FROM ${tables.BoardNodes} WHERE BoardId = ${boardId}`,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Select,
    Delete,
    Companies,
    Tenants,
    NativeAppConf,
    Users,
    Meetings,
    Nodes,
    Boards,
    BoardNodes,
}